export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-italic-9eea8de0e77f57291bfaa76f74def666.svg";